import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AppGlobals } from '@app/app.global';

import { AuthService } from '@core/services';

@Injectable()
export class OwnerGuard implements CanActivate {
    constructor(private router: Router,
        private authService: AuthService,
        private appGlobals: AppGlobals) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.authService.user?.isOwner) {
            return true;
        } else {
            const defaultPath = this.appGlobals.getDefaultLandingPath(this.authService.user);
            this.router.navigate(defaultPath);
            return false;
        }
    }
}